import jqRequest from '../jqRequest'
import loginUrls from '../urls/login'

export default {
  // 获取手机验证码
  getAuthCodeByVerifyCode(data) {
    return jqRequest.requestWithToken(loginUrls.getAuthCodeByVerifyCode, data);
  },
  // 手机验证码登录，获取用户信息
  getMemberByToken(data) {
    return jqRequest.requestWithToken(loginUrls.getMemberByToken, data);
  },
  // 微信授权登录后获取登录信息
  getWeixinMemberInfo(data){
    return jqRequest.requestWithToken(loginUrls.getWeixinMemberInfo, data);
  },
  // 检测手机号是否可用
  mobilePhoneExistForH5(data) {
    return jqRequest.requestWithToken(loginUrls.mobilePhoneExistForH5, data);
  },
  // 绑定手机号
  boundMobilephone(data) {
    return jqRequest.requestWithToken(loginUrls.boundMobilephone, data);
  },
  // 获取图形验证码
  getLoginVerifyCode(data) {
    return jqRequest.requestWithToken(loginUrls.getLoginVerifyCode, data);
  },
}
